// EditMilestoneDrawer.js
import React, { useState, useRef, useEffect } from "react";
import Drawer from "@mui/material/Drawer";
import InputAdornment from '@mui/material/InputAdornment';
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  TextField,
  Button,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import FormControl from "@mui/material/FormControl";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { toast } from "react-toastify";
import {
  updateMilestone,
  updateMilestoneStatus,
} from "../../api/casp/milestone";
import dayjs from "dayjs";
import { MilestoneStatus } from "../../constants/Status";
import { AcceptFileType, Action, DefaultPerPageValue, Review } from "../../constants/Common";
import { useFormik } from "formik";
import * as Yup from "yup";
// import AttachFile from '@material-ui/icons/AttachFile';
import { deleteDocument, documentList, uploadFile } from "../../api/casp/document";
import { DocumentModule, Modules } from "../../constants/Module";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import SweetAlert from "react-bootstrap-sweetalert";
import { getUrl, truncateFileName } from "../../helpers/file_helper";
import Loader from "../Common/Loader";
import DownloadIcon from '@mui/icons-material/Download';
import DocumentFilePreviewModal from "../casp/common/DocumentFilePreviewModal";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
// import { makeStyles } from "@material-ui/core";
import CloseIcon from '@mui/icons-material/Close';
import { withTranslation } from "react-i18next";
import { MilestoneStatusColor } from "../../constants/StatusColor";
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { color } from "echarts";
import ContentInfo from "../../common/contentInfo";
import DescriptionIcon from "@mui/icons-material/Description";
import ShowCommentModal from "../casp/common/ShowCommentModal";
import { AttachFile } from "@mui/icons-material";

const useStyles = makeStyles({
  blueIcon: {
    color: '#296ced',
    cursor: 'pointer'
  },
});

const ViewMilestoneDrawer = ({
  isOpen,
  handleClose,
  selectedRow,
  refresh,
  isDisabled,
  action,
  deliverableId,
  milestoneStaus,
  t
}) => {
  const [milestoneCreationLoading, setMilestoneCreationLoading] =
    useState(false);
  const [disabled, setDisabled] = useState(false);
  const [milstoneObject, setMilestoneObject] = useState({
    name: "",
    weight: "",
    cost: "",
    description: "",
    estimatedStartDate: "",
    estimatedEndDate: "",
    output: "",
  });
  const [isAction, setIsAction] = useState();
  const [loadingDocument, setLoadingDocument] = useState(false);
  const [loadingOtherDocument, setOtherLoadingDocument] = useState(false);
  const [loadingBudget, setLoadingBudget] = useState(false);
  const [selectMilestoneBudget, setSelectMilestoneBudget] = useState();
  const [trigger, setTrigger] = useState(new Date())
  const inputRef = useRef(null)
  const [isOpenSweetAlert, setIsOpenSweetAlert] = useState(false);
  const [documentId, setDocumentId] = useState();
  const [documentOtherId, setDocumenOthertId] = useState();
  const [budgetIndex, setBudgetIndex] = useState();
  const [modal, setModal] = useState(false);
  const [filePath, setFilePath] = useState('');
  const [fileName, setFileName] = useState('');
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [documentUploadType, setDocumentUploadType] = useState();
  const classes = useStyles();
  const [update, setUpdate] = useState(0);
  const [open, setOpen] = useState(false);
  const [rejectReason, setRejectReason] = useState();

  const [milestoneBudget, setMilestoneBudget] = useState({
    otherDocuments: [],
    items: [{
      actualCost: "",
      documents: []
    }]
  })

  const actualCostValidation = Yup.object().shape({
    otherDocuments: Yup.array().min(1, t('Select at least one document')),
    items: Yup.array().of(Yup.object().shape({
      actualCost: Yup.number().moreThan(0, t("Actual cost cannot be 0 or negative")).required(t('Actual cost is required')),
      documents: Yup.array().min(1, t('Documents is required')).max(5, t("You cannot add more than 5 documents"))
    })
    ).required().min(1).max(10)
  });

  const milestoneBudgetFormik = useFormik({
    initialValues: {
      ...milestoneBudget
    },
    validationSchema: actualCostValidation,
    validateOnMount: true,
    onSubmit: (values) => {
    }
  })
  useEffect(() => {
    if (selectedRow) {
      setIsAction(action === Action.VIEW);
      milestoneAttachedDocumentDetails()
      setMilestoneObject(selectedRow);
      if (
        ![MilestoneStatus.DRAFT, MilestoneStatus.REJECTED].includes(
          selectedRow.currentStatus
        ) ||
        isDisabled
      ) {
        setDisabled(true);
      } else {
        setDisabled(false);
      }

      if ((action === Action.VIEW) || (milestoneStaus &&
        milestoneStaus === MilestoneStatus.DONE &&
        selectedRow.milestoneBudgets.length)) {
        getBudgetDetails()
      }
    }
  }, []);

  const milestoneAttachedDocumentDetails = async () => {
    try {
      let params = {
        projectId: selectedRow.project.id,
        filterFields: ['documentAssociations'],
        filterInputs: '',
        module: Modules.MILESTONE,
        moduleId: selectedRow.latestApproval ? selectedRow.latestApproval?.moduleId : selectedRow.id
      };
      const documentData = await documentList(params)
      setSelectedFiles(documentData.data.data.data)
      milestoneBudgetFormik.setFieldValue('otherDocuments', documentData.data.data.data)
    } catch (err) {
      console.log(err)
    }
  }

  const handleValidate = (requiredPayload) => {
    for (const data in requiredPayload) {
      let prefix = data;
      if (prefix.endsWith("Id")) {
        prefix = data.slice(0, data.indexOf("Id"));
      }

      if (!Array.isArray(requiredPayload[data]) && !requiredPayload[data]?.toString().trim()) {
        toast.error(`${prefix} is required`);
        return false;
      }
    }

    return true;
  };

  const handleUpdate = async () => {
    try {
      let requiredPayload = {
        name: milstoneObject.name,
        description: milstoneObject.description,
        projectId: parseInt(selectedRow.project.id),
        deliverableId: parseInt(deliverableId),
        estimatedStartDate: milstoneObject.estimatedStartDate,
        estimatedEndDate: milstoneObject.estimatedEndDate,
        cost: milstoneObject.cost,
        weight: milstoneObject.weight ? parseInt(milstoneObject.weight) : null,
        output: milstoneObject.output,
      };

      if (handleValidate(requiredPayload)) {
        setMilestoneCreationLoading(true);
        const response = await updateMilestone(selectedRow.id, requiredPayload);
        if (response.statusCode === 200) {
          await refresh();
          toast.success(response.data.message);
        } else {
          toast.error(response.data.message);
        }
        setMilestoneCreationLoading(false);
        handleClose();
      }
    } catch (err) {
      setMilestoneCreationLoading(false);
      toast.error(err.message);
    }
  };

  const handleSubmit = async () => {
    try {
      let requiredPayload = {
        projectId: selectedRow.project.id,
        milestoneId: selectedRow.id,
        status: milestoneStaus ?? MilestoneStatus.ONGOING,
        ...(milestoneStaus === MilestoneStatus.DONE && milestoneBudgetFormik.values.items.length > 0 && {
          items: milestoneBudgetFormik.values.items.map((row) => {
            return {
              id: row.id,
              budgetType: row.type,
              actualCost: row.actualCost
            }
          }),
          review: Review.YES // Initially done later review field will be added
        })
      };
      handleValidate(requiredPayload)
      setMilestoneCreationLoading(true);
      const response = await updateMilestoneStatus(
        selectedRow.id,
        requiredPayload
      );
      if (response.statusCode === 200) {
        await refresh();
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
      setMilestoneCreationLoading(false);
      handleClose();
    } catch (err) {
      toast.error(err.message)
      setMilestoneCreationLoading(false);
      console.log(err)
    }
  };

  const handleKeyPress = (event) => {
    if (event.keyCode === 8 || event.keyCode === 13) {
      return;
    }
    const value = event.target.value;
    const regex = /^\d*\.?\d{0,2}$/;

    if (!regex.test(value + event.key)) {
      event.preventDefault();
    }
  }

  const getBudgetDetails = async () => {
    try {
      setLoadingBudget(true)
      const budget = await Promise.all(selectedRow.milestoneBudgets.map(async (eachRow) => {
        let params = {
          projectId: selectedRow.project.id,
          filterFields: ['documentAssociations'],
          filterInputs: '',
          module: [DocumentModule.MILESTONE_BUDGET],
          moduleId: eachRow.id
        };
        const res = (await documentList(params)).data.data;
        return {
          id: eachRow.id,
          type: eachRow.budgetType,
          plannedCost: eachRow.plannedCost,
          actualCost: eachRow.actualCost ?? '',
          documents: res.data
        }
      }))
      milestoneBudgetFormik.setFieldValue("items", budget)
      setMilestoneBudget({ items: budget })
    }
    catch (error) {
      toast.error(error);
    }
    finally {
      setLoadingBudget(false)
    }
  }

  const getDocumentList = async () => {
    try {
      let params = {
        projectId: selectedRow.project.id,
        filterFields: ['documentAssociations'],
        filterInputs: '',
        module: [DocumentModule.MILESTONE_BUDGET],
        moduleId: selectMilestoneBudget.id
      };
      const res = (await documentList(params)).data.data;
      milestoneBudgetFormik.setFieldValue(`items[${budgetIndex}].documents`, res.data)
      setSelectMilestoneBudget()
      setBudgetIndex()
      setTrigger(+new Date())
    }
    catch (error) {
      toast.error(error);
    }
    finally {
      setLoadingDocument(false)
    }
  }

  const handleFileUpload = async (file) => {
    try {
      const fileExtension = file ? `.${file.name.split('.').pop().toLowerCase()}` : '';
      if (file && !AcceptFileType.includes(fileExtension)) {
        file = null;
        return toast.error('Invalid file type')
      }
      if (file.size > (1024 * 1024 * 10)) {
        return toast.error('Payload content length greater than maximum allowed: 10 MB');
      }

      if (milestoneBudgetFormik.values?.items[budgetIndex]?.documents.length >= 5) {
        return toast.error("You cannot add more than 5 documents.");
      }


      setLoadingDocument(true)
      const formData = new FormData();

      formData.append('files', file);
      formData.append('moduleId', selectMilestoneBudget.id);
      formData.append('module', DocumentModule.MILESTONE_BUDGET);
      formData.append('projectId', selectedRow.project.id);
      const result = (await uploadFile(formData)).data.data;

      setUpdate(update + 1)
      getDocumentList()
    } catch (error) {
      setLoadingDocument(false)
    }
  }

  const handleFileUploadForOtherDocument = async (file) => {
    try {
      setDocumentUploadType(DocumentModule.MILESTONE)
      const fileExtension = file ? `.${file.name.split('.').pop().toLowerCase()}` : '';
      if (file && !AcceptFileType.includes(fileExtension)) {
        file = null;
        return toast.error('Invalid file type')
      }
      if (file.size > (1024 * 1024 * 10)) {
        return toast.error('Payload content length greater than maximum allowed: 10 MB');
      }

      setOtherLoadingDocument(true)
      const formData = new FormData();
      formData.append('files', file);
      formData.append('moduleId', selectedRow.id);
      formData.append('module', DocumentModule.MILESTONE);
      formData.append('projectId', selectedRow.project.id);
      const result = (await uploadFile(formData)).data.data;
      setSelectedFiles((prev) => [...prev, result]);
      milestoneBudgetFormik.setFieldValue('otherDocuments', [...selectedFiles, result]);
      setUpdate(update + 1);
      setOtherLoadingDocument(false)
      setDocumentUploadType()
    } catch (error) {
      setOtherLoadingDocument(false)
    }
  }

  const handelDelete = async () => {
    try {
      setIsOpenSweetAlert(false)
      setLoadingDocument(true)
      const res = await deleteDocument(documentId)
      toast.success(res.data.message)
      getDocumentList()
      setLoadingDocument(false)
      setDocumentId()
    } catch (err) {
      setLoadingDocument(false)
      setDocumentId()
      toast.error(err.message)
    }
  }

  const removeFileForOtherDocument = async () => {
    try {
      setIsOpenSweetAlert(false)
      setOtherLoadingDocument(true)
      const res = await deleteDocument(documentOtherId)
      toast.success(res.data.message)
      const leftDocument = selectedFiles.filter(function (item) {
        return item.id !== documentOtherId
      })
      setSelectedFiles(leftDocument)
      milestoneBudgetFormik.setFieldValue('otherDocuments', leftDocument?.length ? leftDocument : [])
      setDocumentUploadType()
      setDocumenOthertId()
      setOtherLoadingDocument(false)
    } catch (err) {
      toast.error(err.message)
      setDocumenOthertId()
      setOtherLoadingDocument(false)
    }
  }

  const onClose = (_, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    handleClose();
  }

  const handleOpen = (comment, data) => {
    setOpen(true);
    setRejectReason({
      name: data?.name,
      profilePicture: data?.profilePicture,
      role: data?.projectUsers[0]?.role?.name ?? '',
      comment,
    });
  };

  const handleRejectModal = () => {
    setOpen(!open);
    setRejectReason()
  };

  return (
    <Drawer anchor="right" open={isOpen} onClose={onClose}
      // PaperProps={{
      //   sx: { width: "1000px" },
      // }}
      className="projectListDrawer"
    >
      <div className="d-flex">
        {/* new design starts here */}
        <div className="editMilestoneDrawer viewMilestoneDrawer p-3 responsiveDrawer">
          <h5>{action === Action.EDIT ? t("Edit Milestone") : (action === Action.VIEW ? t("Milestone Details") : t("Milestone"))}</h5>
          <div>
            <CloseIcon className="crossIcon" onClick={handleClose} />
          </div>
          <div className="innerTbContent milestoneDetailsView">
            <div className="d-flex justify-content-between align-items-center">
              <h5 className="m-0 darker_text bold-text" style={{ fontSize: '20px' }}>{milstoneObject.name}</h5>
              <div className={`statusBadge ${MilestoneStatusColor(selectedRow?.currentStatus)} badge-outlined text-center text-capitalize`}>
                {selectedRow.currentStatus}
                {selectedRow?.currentStatus === MilestoneStatus.SENT_FOR_CONFIRMATION &&
                  <ContentInfo content={selectedRow.latestApproval?.currentApprovalUser} />
                }
                {selectedRow.currentStatus ===
                  MilestoneStatus.CONFIRMATION_REJECTED && (
                    <DescriptionIcon
                      style={{ cursor: "pointer", height: '18px' }}
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        handleOpen(
                          selectedRow.previousApproval?.comments,
                          selectedRow.previousApproval?.currentApprovalUser?.user
                        )
                      }
                      }
                    />
                  )}
              </div>
            </div>
            <p className="detailDesc">{milstoneObject.description}</p>
            <div className="d-grid wrappedData WrappedBorder threeColumns">
              <div className="singleList">
                <div className="detailTitle">{t("Weight")}</div>
                <p className="detailDesc mb-0"> &nbsp;{milstoneObject.weight}</p>
              </div>
              <div className="singleList">
                <div className="detailTitle">{t("Estimated Start Date")}</div>
                <p className="detailDesc mb-0"> &nbsp;{milstoneObject.estimatedStartDate && dayjs(milstoneObject.estimatedStartDate).format('MM/DD/YYYY')}</p>
              </div>
              <div className="singleList">
                <div className="detailTitle">{t("Estimated End Date")}</div>
                <p className="detailDesc mb-0"> &nbsp;{milstoneObject.estimatedEndDate && dayjs(milstoneObject.estimatedEndDate).format('MM/DD/YYYY')}</p>
              </div>
            </div>
            <div className="d-grid wrappedData WrappedBorder twoColumns">
              <div className="singleList">
                <div className="detailTitle">{t("Cost")}</div>
                <p className="detailDesc mb-0">SAR {milstoneObject.cost}</p>
              </div>
            </div>
            <div className="col-sm-12">
              <div className="singleList wrappedData WrappedBorder">
                <div className="detailTitle">{t("Output")}</div>
                <p className="detailDesc mb-0">{milstoneObject.output}</p>
              </div>
              {selectedRow.currentStatus !== MilestoneStatus.DRAFT && (
                <>
                  <div className="WrappedBorder pt-3">

                    {action !== Action.VIEW ? (
                      <div className="w-100 d-flex align-items-center justify-content-between wrappedData">
                        <span>{t("Attachments")}</span>
                        <div className="uploaded_file">
                          <div key={trigger} className="globalAttachmentBrowse position-relative">
                            <AttachFile
                              className="attachment_button"
                              style={{ cursor: 'pointer' }}
                            />
                            <span className="mx-2">{t("Browse")}</span>
                            <input
                              key={update}
                              type="file"
                              accept={AcceptFileType.toString()}
                              name="otherDocuments"
                              onChange={(e) => handleFileUploadForOtherDocument(e.target.files[0])}
                              onBlur={() => {
                                if (!milestoneBudgetFormik.touched?.otherDocuments) {
                                  milestoneBudgetFormik.setFieldTouched("otherDocuments", true, false);
                                }
                              }}
                              className="browse_attachment_inpt"
                            />
                          </div>
                        </div>
                      </div>
                    ) : (
                      <h5 className="mb-0">{t("Attachments")}</h5>
                    )}

                  </div>
                  <div className="mx-3">
                    {milestoneBudgetFormik.touched.otherDocuments && milestoneBudgetFormik.errors.otherDocuments && (
                      <span className="text-danger">{milestoneBudgetFormik.errors.otherDocuments} </span>
                    )}
                  </div>
                  {loadingOtherDocument && <Loader />}
                  <div className="d-grid globalAttachmentList mb-3">
                    {
                      !loadingOtherDocument && selectedFiles?.length > 0 && selectedFiles.map((file, key) => (
                        <>
                          <div className='singleAttachment mt-1 d-flex align-items-center justify-content-between' key={key}>
                            <div className="d-flex align-items-center">
                              <div className="attachmentFileIcon">
                                <DescriptionOutlinedIcon />
                              </div>
                              <span className='fw-semibold text-truncate' style={{ width: '150px', display: 'inline-block' }}>{file?.name} </span>
                            </div>
                            <div className="attachmentActionsIcon">
                              <RemoveRedEyeOutlinedIcon className={classes.blueIcon} style={{ color: '#7E899F' }} onClick={() => {
                                setModal(true)
                                setFilePath(getUrl(file.storageLink))
                                setFileName(file.name)
                              }
                              } />
                              <a style={{ cursor: 'pointer', color: '#7E899F' }} href={`${getUrl(file.storageLink)}?httpResponseContentDisposition=attachment%3B%20filename%3D${file.name}`} download >
                                <DownloadIcon />
                              </a>

                              {action !== Action.VIEW && (
                                <DeleteOutlineOutlinedIcon
                                  className="mx-2"
                                  style={{ cursor: 'pointer', color: '#F07676' }}
                                  onClick={() => {
                                    setDocumentUploadType(DocumentModule.MILESTONE)
                                    setDocumenOthertId(file.id)
                                    setIsOpenSweetAlert(true)
                                  }}
                                />
                              )}
                            </div>
                          </div>
                        </>
                      ))
                    }
                  </div>
                </>
              )}
              <div className="main_single_item">
                {!loadingBudget && milestoneBudgetFormik.values.items && milestoneBudgetFormik.values.items?.length > 0 &&
                  milestoneBudgetFormik.values?.items?.map((_row, index) => (
                    <div className="inner_one" key={index}>
                      <div className="d-grid wrappedData threeColumns">
                        <div className="singleList">
                          <div className="detailTitle">{t("Planned Cost")}</div>
                          <p>SAR {_row.plannedCost}</p>
                        </div>
                        <div className="singleList" >
                          <div className="detailTitle">{t("Actual Cost")}
                            {action === Action.VIEW ? '' : <span style={{ color: '#FF3A3A' }}>*</span>}
                          </div>
                          {action === Action.VIEW ?
                            <p>SAR {milestoneBudgetFormik.values.items[index]?.actualCost}</p>
                            :
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                              <TextField
                                label=""
                                variant="outlined"
                                type="number"
                                size="small"
                                placeholder=""
                                onKeyDown={handleKeyPress}
                                onWheel={(e) => e.target.blur()}
                                name={`items.${index}.actualCost`}
                                fullWidth
                                value={milestoneBudgetFormik.values.items[index]?.actualCost}
                                onChange={milestoneBudgetFormik.handleChange}
                                onBlur={milestoneBudgetFormik.handleBlur}
                                required
                                InputProps={{
                                  startAdornment: <InputAdornment position="start">SAR</InputAdornment>,
                                  // readOnly: action && action === Action.VIEW ? true : false,
                                }}
                              />
                              {action !== Action.VIEW && milestoneBudgetFormik.touched.items &&
                                milestoneBudgetFormik.touched.items.length &&
                                milestoneBudgetFormik.touched?.items[index] &&
                                milestoneBudgetFormik.touched?.items[index]?.actualCost &&
                                milestoneBudgetFormik.errors.items &&
                                milestoneBudgetFormik.errors?.items.length > 0 &&
                                milestoneBudgetFormik.errors?.items[index] &&
                                milestoneBudgetFormik.errors?.items[index]?.actualCost && (
                                  <span className="text-danger small">
                                    {milestoneBudgetFormik.errors?.items[index]?.actualCost}
                                  </span>
                                )}
                            </div>
                          }
                        </div>
                        <div className="singleList">
                          <div className="detailTitle">{t("Budget Type")}</div>
                          <p className="detailDesc mb-0">{_row.type}</p>
                        </div>
                      </div>
                      <div className="`inner_Uploaded_box $((_row.documents.length > 0) && ( pr_border)`">
                        {action !== Action.VIEW ?
                          <div className="w-100 d-flex align-items-center justify-content-between wrappedData px-0">
                            <h6 className="documentTitle mb-0 fw-semibold">{t("Documents")}</h6>

                            <div className="fileUploadInput globalAttachmentBrowse position-relative" onClick={(e) => {
                              setSelectMilestoneBudget(_row)
                              setBudgetIndex(index)
                              milestoneBudgetFormik.setFieldTouched(`items[${index}].documents`, true, true);
                            }}>
                              <AttachFile
                                className="attachment_button"
                                style={{ cursor: 'pointer' }}
                              // onClick={(e) => {
                              //   // inputRef.current.click()
                              //   setSelectMilestoneBudget(_row)
                              //   setBudgetIndex(index)
                              //   milestoneBudgetFormik.setFieldTouched(`items[${index}].documents`, true, true);
                              // }}
                              />
                              <span className="mx-2">{t('Browse')}</span>
                              <input
                                key={update}
                                type='file'
                                accept={AcceptFileType.toString()}
                                onChange={(e) => {
                                  handleFileUpload(e.target.files[0])
                                }}
                                //ref={inputRef} 
                                className="browse_attachment_inpt"
                                single
                                name={`items.${index}.documents`}
                                onBlur={milestoneBudgetFormik.handleBlur}
                              />
                            </div>

                            {milestoneBudgetFormik.touched.items &&
                              milestoneBudgetFormik.touched.items.length &&
                              milestoneBudgetFormik.touched?.items[index] &&
                              milestoneBudgetFormik.touched?.items[index]?.documents &&
                              milestoneBudgetFormik.errors.items &&
                              milestoneBudgetFormik.errors?.items.length > 0 &&
                              milestoneBudgetFormik.errors?.items[index] &&
                              milestoneBudgetFormik.errors?.items[index]?.documents && (
                                <span className="text-danger small">
                                  {milestoneBudgetFormik.errors?.items[index]?.documents}
                                </span>
                              )}
                          </div>
                          :
                          (_row.documents.length > 0) && (<h6 className="documentTitle mb-0 py-2 fw-semibold">{t("Documents")}</h6>)
                        }
                        {/* <div> */}
                        {!loadingDocument && _row?.documents && _row.documents?.length > 0 &&


                          <div key={trigger} className="d-grid globalAttachmentList">
                            {
                              _row.documents?.map((file, key) => (
                                <div className='singleAttachment mt-1 d-flex align-items-center justify-content-between' key={key}>
                                  <div className="d-flex align-items-center">
                                    <div className="attachmentFileIcon">
                                      <DescriptionOutlinedIcon />
                                    </div>
                                    <span
                                      className='me-3 fw-semibold text-truncate'
                                      style={{ cursor: 'pointer', width: '120px' }}
                                      onClick={() => {
                                        setModal(true)
                                        setFilePath(getUrl(file?.storageLink))
                                        setFileName(file?.name)
                                      }}
                                    >{truncateFileName(file?.name, 20)} </span>
                                  </div>
                                  <div className="attachmentActionsIcon">
                                    <RemoveRedEyeOutlinedIcon className={classes.blueIcon} style={{ color: '#7E899F' }} onClick={() => {
                                      setModal(true)
                                      setFilePath(getUrl(file.storageLink))
                                      setFileName(file.name)
                                    }
                                    } />
                                    <a style={{ cursor: 'pointer', color: '#7E899F' }} href={`${getUrl(file.id)}?httpResponseContentDisposition=attachment%3B%20filename%3D${file.name}`} download >
                                      <DownloadIcon />
                                    </a>
                                    {action !== Action.VIEW &&
                                      <DeleteOutlineOutlinedIcon
                                        className="mx-2"
                                        style={{ cursor: 'pointer', color: '#F07676' }}
                                        onClick={() => {
                                          setSelectMilestoneBudget(_row)
                                          setDocumentId(file?.id)
                                          setBudgetIndex(index)
                                          setIsOpenSweetAlert(true)
                                        }}
                                      />
                                    }
                                  </div>
                                </div>

                              ))
                            }
                          </div>
                        }
                        {loadingDocument && budgetIndex === index && <Loader />}
                      </div>
                    </div>

                    // </div>
                  )
                  )}
              </div>

            </div>

          </div>
          <div className="plsubmitButton remove_border">
            {[MilestoneStatus.DRAFT, MilestoneStatus.REJECTED].includes(
              selectedRow.currentStatus
            ) &&
              action === Action.EDIT &&
              !isDisabled && (
                // <ListItem className="justify-content-center">
                <Button
                  onClick={handleUpdate}
                  disabled={milestoneCreationLoading}
                  variant="contained"
                >
                  {t("Save")}
                </Button>
                // </ListItem>
              )}
            {(action !== Action.VIEW && (milestoneStaus && milestoneStaus === MilestoneStatus.DONE)) &&
              [MilestoneStatus.ONGOING, MilestoneStatus.CONFIRMATION_REJECTED].includes(
                selectedRow.currentStatus
              ) && (
                // <ListItem className="justify-content-center">
                <Button
                  onClick={handleSubmit}
                  disabled={milestoneCreationLoading || (!milestoneBudgetFormik.isValid)}
                  variant="contained"
                >
                  {t("Submit")}
                </Button>
                // </ListItem>
              )}


          </div>
          {
            isOpenSweetAlert && (
              <SweetAlert
                title="Are you sure you want to delete this document?"
                warning
                showCancel
                confirmButtonText="Yes, delete it!"
                confirmBtnBsStyle="success"
                cancelBtnBsStyle="danger"
                onConfirm={() => {
                  documentUploadType === DocumentModule.MILESTONE ? removeFileForOtherDocument() : handelDelete()
                }}
                onCancel={() => {
                  setIsOpenSweetAlert(false)
                }}>
              </SweetAlert>
            )
          }

          {
            modal && (
              <DocumentFilePreviewModal modal={modal} setModal={setModal} filePath={filePath} fileName={fileName} />
            )
          }
        </div>
        {/* older design starts here */}
        {/* <Drawer anchor="right" open={isOpen} onClose={handleClose}
      PaperProps={{
        sx: { width: "580px" },
      }}
      className="projectListDrawer"
    > */}

        {
          isOpenSweetAlert && (
            <SweetAlert
              title="Are you sure want to delete this document?"
              warning
              showCancel
              confirmButtonText="Yes, delete it!"
              confirmBtnBsStyle="success"
              cancelBtnBsStyle="danger"
              onConfirm={() => {
                documentUploadType === DocumentModule.MILESTONE ? removeFileForOtherDocument() : handelDelete()
              }}
              onCancel={() => {
                setIsOpenSweetAlert(false)
              }}>
            </SweetAlert>
          )
        }

        {
          modal && (
            <DocumentFilePreviewModal modal={modal} setModal={setModal} filePath={filePath} fileName={fileName} />
          )
        }
        <div className="rejectModal">
          <ShowCommentModal
            handleRejectModal={handleRejectModal}
            open={open}
            module={Modules.MILESTONE}
            data={rejectReason}
          />
        </div>

      </div>
    </Drawer >
  );
};

export default withTranslation()(ViewMilestoneDrawer);
